export function extractRemoteMarkup(html, selector) {
	const doc = new DOMParser().parseFromString(
		html.replace(/png'/g, "png"),
		"text/html"
	)
	const fragment = doc.querySelector(selector)

	if (!fragment) {
		return null
	}

	fragment.querySelectorAll("noscript").forEach((node) => node.remove())
	if (fragment.classList.contains("lazy-bg")) {
		fragment.classList.add("visible")
	}
	fragment.querySelectorAll(".lazy-bg").forEach((node) => {
		node.classList.add("visible")
	})
	fragment.querySelectorAll("img[data-src]").forEach((img) => {
		const dataSrc = img.getAttribute("data-src")
		const currentSrc = img.getAttribute("src") || ""

		if (dataSrc && (!currentSrc || currentSrc.startsWith("data:image/"))) {
			img.setAttribute("src", dataSrc)
		}

		const className = img.getAttribute("class") || ""
		if (className.includes("lazyload")) {
			img.setAttribute(
				"class",
				className.replace(/\blazyload\b/g, "lazyloaded").replace(/\s+/g, " ").trim()
			)
		}
	})

	if (fragment.matches("header.site-header")) {
		normalizeHeaderDropdowns(fragment)
	}

	return fragment.outerHTML
}

function normalizeHeaderDropdowns(fragment) {
	const primaryNav = fragment.querySelector("#menu-primary-nav-columned")

	if (!primaryNav) {
		return
	}

	primaryNav
		.querySelectorAll(":scope > li.menu-item-has-children > ul.sub-menu")
		.forEach((subMenu) => {
			if (subMenu.parentElement.querySelector(":scope > .desktop-dropdown")) {
				return
			}

			const dropdown = fragment.ownerDocument.createElement("div")
			dropdown.className = "desktop-dropdown"
			subMenu.parentElement.insertBefore(dropdown, subMenu)
			dropdown.appendChild(subMenu)
		})
}